<template>
  <v-layout class="inner-pages" column >
    <Header />



    <scroll-data :footer="false" :fillHeight="false">

      <v-layout column class="align-self-start">
        <v-flex>
          <v-tabs color="transparent" light slider-color="blue" :value="section">
            <v-tab ripple href="#reports">Reports</v-tab>
            <v-tab ripple href="#manage-employee">Manage Employee</v-tab>
            <v-tab-item value="reports"><reports /></v-tab-item>
            <v-tab-item value="manage-employee" ><manage-employee /></v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>

    </scroll-data>
  </v-layout>
</template>

<script>
  import ScrollData from '../ScrollData'
  import Header from '../layouts/Header'
  import Reports from './manager-actions/Report.vue'
  import ManageEmployee from './manager-actions/ManageEmployee.vue'

  export default {
    name: 'ComplianceCenter',
    components: { Header, ScrollData, Reports, ManageEmployee },
    data: () => ({
      section: 'reports'
    }),
    computed: {},
    created () {
      setTimeout(() => {
        this.$store.commit('setIsCompactHeader', false)
      }, 500)
    },
    methods: {},
    watch: {}
  }
  </script>




// WEBPACK FOOTER //
// src/components/views/ManagerActions.vue